import { render, staticRenderFns } from "./CCMAllergyAdd.vue?vue&type=template&id=439c90b7"
import script from "./CCMAllergyAdd.vue?vue&type=script&lang=js"
export * from "./CCMAllergyAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports